import { AlertError, AlertInfo, AlertWarning } from "../Tools/SweetAlerts";
import toastr from "toastr";

export interface IError {
    data: {
        Title: string;
        title: string;
        ErroFormal: string;
        ErroInformal: string;
        erroFormal: string;
        erroInformal: string;

        errors?: {
            [field: string]: Array<string>;
        };
    };
    status: number;
}
export class APIError {
    public Title!: string;
    public title!: string;
    public ErroFormal!: string;
    public ErroInformal!: string;
    public erroFormal!: string;
    public erroInformal!: string;
    constructor(error: Partial<IError["data"]>) {
        this.Title = error.Title ?? "";
        this.title = error.title ?? "";
        this.ErroFormal = error.ErroFormal ?? "";
        this.ErroInformal = error.ErroInformal ?? "";
        this.erroFormal = error.erroFormal ?? "";
        this.erroInformal = error.erroInformal ?? "";
    }
}

export async function ValidationErr(err?: IError) {
    if (err && err.data) {
        const {
            ErroInformal,
            ErroFormal,
            Title,
            title,
            erroFormal,
            erroInformal,
            errors,
        } = err.data;

        if (errors) {
            const finalErrorString = Object.values(errors).reduce(
                (errorString, localerrors) =>
                    `${errorString}\n${localerrors.reduce(
                        (localerrorString, erro) =>
                            `${localerrorString}\n${erro}`
                    )}`,
                ""
            );

            AlertWarning(
                finalErrorString,
                "Tivemos alguns erros de validação:"
            );
        } else {
            if (err.status === 401 && localStorage.getItem("@token"))
                localStorage.removeItem("@token");
            else if (err.status === 404) AlertInfo(Title || title);
            else if (err.status === 201) AlertInfo(Title || title);
            else if (err.status === 403)
                AlertInfo(
                    (Title || title) +
                        "<br/>" +
                        ((ErroFormal || erroFormal) + "<br/>") +
                        (ErroInformal || erroInformal)
                );
            else
                AlertError(
                    Title || title,
                    ErroInformal || erroInformal,
                    ErroFormal || erroFormal
                );
        }
    } else
        toastr.error(
            "Não foi possível se conectar com o servidor, cheque a sua conexão com a internet",
            "Erro de Conexão"
        );
}
